import type { BaseIconProps } from "@/assets/icons/utils";
import type { FC } from "react";

export const IconWarningCircle: FC<BaseIconProps> = ({ size, className, ...props }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    className={className}
                    {...props}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#clip0_513_37)">
                        <g clipPath="url(#clip1_513_37)">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M12.6875 7C12.6875 10.1412 10.1412 12.6875 7 12.6875C3.85888 12.6875 1.3125 10.1412 1.3125 7C1.3125 3.85888 3.85888 1.3125 7 1.3125C10.1412 1.3125 12.6875 3.85888 12.6875 7ZM14 7C14 10.866 10.866 14 7 14C3.134 14 0 10.866 0 7C0 3.134 3.134 0 7 0C10.866 0 14 3.134 14 7ZM7.65622 3.5V4.15625V6.34375V7H6.34372V6.34375V4.15625V3.5H7.65622ZM7 10.5C7.48323 10.5 7.87497 10.1083 7.87497 9.625C7.87497 9.1417 7.48323 8.75 7 8.75C6.51673 8.75 6.12497 9.1417 6.12497 9.625C6.12497 10.1083 6.51673 10.5 7 10.5Z"
                                fill="currentColor"
                            />
                        </g>
                    </g>
                    <defs>
                        <clipPath id="clip0_513_37">
                            <rect width="14" height="14" fill="white" />
                        </clipPath>
                        <clipPath id="clip1_513_37">
                            <rect width="14" height="14" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            );
        case "base":
            return (
                <svg
                    className={className}
                    {...props}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#clip0_513_40)">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M16.5 10C16.5 13.5899 13.5899 16.5 10 16.5C6.41015 16.5 3.5 13.5899 3.5 10C3.5 6.41015 6.41015 3.5 10 3.5C13.5899 3.5 16.5 6.41015 16.5 10ZM18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM10.75 6.75V7.5V10V10.75H9.24997V10V7.5V6.75H10.75ZM10 14C10.5523 14 11 13.5523 11 13C11 12.4477 10.5523 12 10 12C9.44769 12 9 12.4477 9 13C9 13.5523 9.44769 14 10 14Z"
                            fill="currentColor"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_513_40">
                            <rect width="16" height="16" fill="white" transform="translate(2 2)" />
                        </clipPath>
                    </defs>
                </svg>
            );
        case "lg":
            return (
                <svg
                    className={className}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#clip0_513_43)">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M19.3125 12C19.3125 16.0386 16.0386 19.3125 12 19.3125C7.96142 19.3125 4.6875 16.0386 4.6875 12C4.6875 7.96142 7.96142 4.6875 12 4.6875C16.0386 4.6875 19.3125 7.96142 19.3125 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02943 21 3 16.9706 3 12C3 7.02943 7.02943 3 12 3C16.9706 3 21 7.02943 21 12ZM12.8437 8.34375V9.1875V12V12.8438H11.1562V12V9.1875V8.34375H12.8437ZM12 16.5C12.6213 16.5 13.125 15.9963 13.125 15.375C13.125 14.7537 12.6213 14.25 12 14.25C11.3787 14.25 10.875 14.7537 10.875 15.375C10.875 15.9963 11.3787 16.5 12 16.5Z"
                            fill="currentColor"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_513_43">
                            <rect width="18" height="18" fill="white" transform="translate(3 3)" />
                        </clipPath>
                    </defs>
                </svg>
            );
    }
};
